import { ReactComponent as SorryIcon } from '../../../shared/assets/icons/sorry-icon/sorry.svg';
import Box from '../../../shared/components/ui/Box';
import Typography from '../../../shared/components/ui/Typography';

export const NoMandantsAssigned = (): JSX.Element => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
    }}
  >
    <SorryIcon />

    <Typography
      sx={{
        fontSize: '24px',
        fontWeight: '236px',
        marginTop: '16px',
        color: theme => theme.palette.appGrey.darkGray,
      }}
    >
      You have no principles assigned to you account, please contact the
      administrator.
    </Typography>
  </Box>
);
